import React from "react";
import { motion } from "framer-motion";

export default function AnimateCenter({ children, delay, ...props }) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        delay: delay || 0,
      }}
      viewport={{ once: true }}
      {...props}
    >
      {children}
    </motion.div>
  );
}
